import { loyaltyPageSettingsSchema } from "@redotech/redo-loyalty-common/loyalty-page-builder/definition";
import * as z from "zod/v4";

export const updateLoyaltyPageSettings = {
  name: "updateLoyaltyPageSettings" as const,
  input: loyaltyPageSettingsSchema,
  output: z.object({ success: z.boolean() }),
};
